<script setup lang="ts">
import { useVehicleStore } from '../../stores/vehicleStore'
import RegNrSearch from './RegNrSearch.vue'
import ManualCarSelect from './ManualCarSelect.vue'
import OemSearch from './OemSearch.vue'
import MotorCodeSearch from './MotorCodeSearch.vue'
import SearchHistory from './SearchHistory.vue'

const vehicleStore = useVehicleStore()

function setMode(mode: 'regnr' | 'manual' | 'oem' | 'motorcode') {
  vehicleStore.searchMode = mode
}
</script>

<template>
  <div class="search-panel">
    <div class="search-panel__header">
      <h3>Finn riktig del til bilen</h3>
    </div>

    <div class="search-panel__body">
      <RegNrSearch v-if="vehicleStore.searchMode === 'regnr'" />
      <ManualCarSelect v-else-if="vehicleStore.searchMode === 'manual'" />
      <OemSearch v-else-if="vehicleStore.searchMode === 'oem'" />
      <MotorCodeSearch v-else-if="vehicleStore.searchMode === 'motorcode'" />
    </div>

    <div class="search-panel__links">
      <a v-if="vehicleStore.searchMode !== 'regnr'" href="#" @click.prevent="setMode('regnr')">Regnr</a>
      <a v-if="vehicleStore.searchMode !== 'manual'" href="#" @click.prevent="setMode('manual')">Bilmodell</a>
      <a v-if="vehicleStore.searchMode !== 'oem'" href="#" @click.prevent="setMode('oem')">OE-nummer</a>
      <a v-if="vehicleStore.searchMode !== 'motorcode'" href="#" @click.prevent="setMode('motorcode')">Motorkode</a>
    </div>

    <SearchHistory />

    <div v-if="vehicleStore.searchError" class="search-panel__error">
      {{ vehicleStore.searchError }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.search-panel {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;

  &__header h3 {
    margin-bottom: 1rem;
  }

  &__links {
    margin-top: 0.75rem;
    font-size: 0.9rem;
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    flex-wrap: wrap;

    a {
      text-decoration: underline;
      cursor: pointer;

      &:not(:last-child)::after {
        content: ' ·';
        text-decoration: none;
        margin-left: 0.5rem;
        color: #999;
      }
    }
  }

  &__error {
    margin-top: 1rem;
    padding: 0.75rem;
    background: #fef2f2;
    color: #991b1b;
    border-radius: 6px;
    font-size: 0.9rem;
  }
}
</style>
